import React from 'react';

const SvgLinkedin = props => (
    <svg width="1em" height="1em" viewBox="0 0 14 14" {...props}>
        <path d="M13.3875 0H0.6125C0.2625 0 0 0.2625 0 0.6125V13.475C0 13.7375 0.2625 14 0.6125 14H13.475C13.825 14 14.0875 13.7375 14.0875 13.3875V0.6125C14 0.2625 13.7375 0 13.3875 0ZM4.1125 11.9H2.1V5.25H4.2V11.9H4.1125ZM3.15 4.375C2.45 4.375 1.925 3.7625 1.925 3.15C1.925 2.45 2.45 1.925 3.15 1.925C3.85 1.925 4.375 2.45 4.375 3.15C4.2875 3.7625 3.7625 4.375 3.15 4.375ZM11.9 11.9H9.8V8.6625C9.8 7.875 9.8 6.9125 8.75 6.9125C7.7 6.9125 7.525 7.7875 7.525 8.6625V11.9875H5.425V5.25H7.4375V6.125C7.7 5.6 8.4 5.075 9.3625 5.075C11.4625 5.075 11.8125 6.475 11.8125 8.225V11.9H11.9Z"
              fill="black"
              fillRule="nonzero"
        />
    </svg>
);

export default SvgLinkedin;
